import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const RadioFilled2 = ({
  size = 20,
  style,
  fill: fillProp,
  background: backgroundProp,
}: IconProps & { background?: string }) => {
  const { theme } = useTheme();

  const fill = fillProp ?? theme.radio.inner;
  const background = backgroundProp ?? theme.radio.filled;

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" style={style}>
      <rect width="20" height="20" rx="10" fill={background} />
      <rect x="6" y="6" width="8" height="8" rx="4" fill={fill} />
    </svg>
  );
};
